import React from "react";
import { Text } from "web/react/emo/text";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./view-seller-details.css";

export function ViewSellerDetails(): React.ReactElement {
    return (
        <div
            data-testid="buy-option-card-view-seller-details"
            className={styles.viewSellerDetailsButton}
            onClick={() => {}}
        >
            <Text textStyle="body-xs" underline>
                {gettext("product.view_seller_details")}
            </Text>
        </div>
    );
}
